import { Suspense, useEffect } from 'react'
import { RouterProvider } from 'react-router-dom'
import { router } from '@/routes'
import { Toaster } from 'sonner'
import { AuthProvider } from '@/features/auth/providers/auth-provider'
import { CaptchaProvider } from '@/features/captcha/captcha-provider'
import { ThemeProvider } from '@/components/theme-provider'
import { useThemeStore } from '@/store/theme-store'
import { useMaintenanceCheck } from '@/store/maintenance-store'
import { Loading } from '@/components/ui/loading'
import MaintenancePage from '@/pages/MaintenancePage'
import './index.css'

// Componente de Loading
function AppLoading() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <Loading size="lg" message="Carregando aplicação..." />
    </div>
  )
}

export function App() {
  const { setTheme } = useThemeStore();
  const isMaintenanceActive = useMaintenanceCheck();

  // Hidrata o tema do localStorage
  useEffect(() => {
    const storedTheme = localStorage.getItem('theme-storage')
    if (storedTheme) {
      const theme = JSON.parse(storedTheme).state.theme
      setTheme(theme)
    }
  }, [setTheme])

  // Se modo manutenção está ativo, força logout e exibe página de manutenção
  useEffect(() => {
    if (isMaintenanceActive) {
      // Força logout imediatamente quando modo manutenção é detectado
      const performMaintenanceLogout = async () => {
        try {
          console.log('Modo manutenção detectado - Limpando sessões')
          
          // Limpa localStorage
          localStorage.removeItem('ephemeral-cards-auth')
          localStorage.removeItem('ephemeral-cards-session')
          
          // Limpa tokens do Supabase
          const supabaseKey = 'sb-' + import.meta.env.VITE_SUPABASE_URL?.split('//')[1] + '-auth-token'
          localStorage.removeItem(supabaseKey)
          
          // Força reload para garantir limpeza completa
          setTimeout(() => {
            window.location.reload()
          }, 1000)
        } catch (error) {
          console.error('Erro ao limpar sessões para manutenção:', error)
        }
      }
      
      performMaintenanceLogout()
    }
  }, [isMaintenanceActive])

  // Se modo manutenção está ativo, força a página de manutenção
  if (isMaintenanceActive) {
    return (
      <ThemeProvider>
        <MaintenancePage />
        <Toaster 
          theme="system" 
          position="top-right"
          richColors
          closeButton
        />
      </ThemeProvider>
    )
  }

  return (
    <ThemeProvider>
      <AuthProvider>
        <CaptchaProvider>
          <Suspense fallback={<AppLoading />}>
            <RouterProvider router={router} />
            <Toaster 
              theme="system" 
              position="top-right"
              richColors
              closeButton
            />
          </Suspense>
        </CaptchaProvider>
      </AuthProvider>
    </ThemeProvider>
  )
}

export default App
